import { Mount } from "@shared/enums";
import { isMount, MOUNTS } from "@shared/values";

/** Listing policy: a camera using a sub-mount also accepts lenses for its parent mount. */
export const getListingCompatibleLensMounts = (selected: readonly Mount[]): Mount[] => {
  const compatible = new Set<Mount>();
  selected.forEach((mount) => {
    compatible.add(mount);
    if (mount.endsWith("1")) {
      const parent = `${mount.slice(0, -1)}0`;
      if (isMount(parent)) compatible.add(parent);
    }
  });
  return MOUNTS.map(({ public_id }) => public_id).filter((mount) => compatible.has(mount));
};

export type LensCompatibilitySelection =
  | { mode: "none" }
  | { mode: "mounts"; mounts: readonly Mount[] }
  | { mode: "camera"; camera: { id: string; name: string; mount: Mount } };

export const selectListingMounts = (mounts: readonly Mount[]): LensCompatibilitySelection =>
  mounts.length ? { mode: "mounts", mounts } : { mode: "none" };

export const selectListingCamera = (camera: { id: string; name: string; mount: Mount }): LensCompatibilitySelection =>
  ({ mode: "camera", camera });

export const getCompatibleMountsForSelection = (selection: LensCompatibilitySelection): Mount[] =>
  getListingCompatibleLensMounts(selection.mode === "camera" ? [selection.camera.mount]
    : selection.mode === "mounts" ? selection.mounts : []);
